import { render, staticRenderFns } from "./CsRevisionTarifasAdicionales.vue?vue&type=template&id=4b5169b2"
import script from "./CsRevisionTarifasAdicionales.vue?vue&type=script&lang=js"
export * from "./CsRevisionTarifasAdicionales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports